import React from 'react';

export default function MainContentWrapper(props: any) {

    return (
        <div className="mdk-header-layout__content page-content" style={{backgroundColor: props.bgColor?props.bgColor:'white'}}>
            <div className="mdk-drawer-layout js-mdk-drawer-layout">
                <div className="mdk-drawer-layout__content page-content mt-3">
                    {props.children}
                </div>
            </div>
        </div>
    );
}
